<header class="station-header">
  <div class="station-logo-container">
    <a href="https://www.dance895.org/" target="_blank" aria-label="Open Dance 89.5 website in a new tab">
      <img src="assets/block-logo.svg" alt=""/>
    </a>
  </div>
  <div class="app-name">
    <div class="header-player max-w-150 ml-auto mr-auto text-center sm:mt-1">
      <knhc-player></knhc-player>
    </div>
  </div>
  <div class="donate-button-container">
    <a href="https://www.dance895.org/donate/" class="donate-button" target="_blank">
      <div class="contribute-link">DONATE</div>
    </a>
  </div>
</header>
